<template>
  <div class="signin">
    <h2>Sign out</h2>
    <p>You don't have an account?
      <router-link to="/signin">ログインする</router-link>
    </p>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'Signout',
  mounted: () => {
    firebase.auth().onAuthStateChanged((user) => {
      firebase.auth().signOut().then(() => {
        console.log('ログアウトしました')
      }).catch((error) => {
        console.log(`ログアウト時にエラーが発生しました (${error})`)
      })
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.signin {
  margin-top: 20px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center
}
input {
  margin: 10px 0;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Signout.vue